/* Southern Lumen - wishlist ("save my build")
   Browser-local, no account needed: saved items live in localStorage, so it fits
   the store's no-login checkout. Hearts on product cards + PDP gallery toggle an
   item; a header count and the /pages/wishlist page read the same store. All UI
   is data-attribute driven so it hydrates whatever is on the page. */
(function () {
  var KEY = 'sl_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} document.dispatchEvent(new CustomEvent('sl-wishlist-change')); }
  function has(h) { return read().some(function (x) { return x.h === h; }); }
  function toggle(item) {
    if (!item || !item.h) return false;
    var a = read(), i = -1;
    a.forEach(function (x, k) { if (x.h === item.h) i = k; });
    if (i >= 0) a.splice(i, 1); else a.unshift(item);
    write(a); return has(item.h);
  }
  function remove(h) { write(read().filter(function (x) { return x.h !== h; })); }
  window.SLWishlist = { list: read, has: has, toggle: toggle, remove: remove, count: function () { return read().length; } };

  function money(c) {
    c = parseInt(c, 10); if (isNaN(c) || c <= 0) return '';
    return '$' + (c / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function syncButtons() {
    var saved = read();
    [].forEach.call(document.querySelectorAll('[data-sl-wish]'), function (b) {
      var on = saved.some(function (x) { return x.h === b.getAttribute('data-wish-handle'); });
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lab = b.querySelector('[data-wish-label]');
      if (lab) lab.textContent = on ? 'Saved' : 'Save';
    });
  }
  function syncCount() {
    var n = read().length;
    [].forEach.call(document.querySelectorAll('[data-sl-wish-count]'), function (el) {
      el.textContent = n; el.hidden = (n === 0);
    });
  }
  function renderPage() {
    var wrap = document.querySelector('[data-sl-wishlist-page]');
    if (!wrap) return;
    var items = read();
    var empty = document.querySelector('[data-sl-wishlist-empty]');
    if (!items.length) { wrap.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    wrap.innerHTML = items.map(function (x) {
      var img = x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" decoding="async">' : '';
      var price = x.p ? '<span class="sl-wishcard__price">' + money(x.p) + '</span>' : '';
      return '<li class="sl-wishcard">' +
        '<a class="sl-wishcard__media sl-frame sl-frame--light" href="' + esc(x.u) + '">' + img + '</a>' +
        '<div class="sl-wishcard__body">' +
          '<a class="sl-wishcard__title" href="' + esc(x.u) + '">' + esc(x.t) + '</a>' + price +
          '<div class="sl-wishcard__actions">' +
            '<a class="sl-btn sl-btn--sm" href="' + esc(x.u) + '">View</a>' +
            '<button type="button" class="sl-wishcard__rm" data-wish-remove="' + esc(x.h) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sl-wish]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      toggle({
        h: btn.getAttribute('data-wish-handle'),
        t: btn.getAttribute('data-wish-title'),
        u: btn.getAttribute('data-wish-url'),
        i: btn.getAttribute('data-wish-img'),
        p: btn.getAttribute('data-wish-price')
      });
      return;
    }
    var rm = e.target.closest && e.target.closest('[data-wish-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-wish-remove')); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-sl-wish]')) { e.preventDefault(); e.target.click(); }
  });

  function syncAll() { syncButtons(); syncCount(); renderPage(); }
  document.addEventListener('sl-wishlist-change', syncAll);
  if (document.readyState !== 'loading') syncAll(); else document.addEventListener('DOMContentLoaded', syncAll);
})();
